"use strict";


document.addEventListener('DOMContentLoaded', () => {
    const elevator = document.querySelector('.levels .icon img');
    const section = document.querySelector('.levels .icon');

    if (!elevator || !section) return;

    elevator.addEventListener('animationend', () => {
        elevator.classList.add('scroll-active');

        const handleScroll = () => {
            const rect = section.getBoundingClientRect();
            const windowHeight = window.innerHeight;
            const startThreshold = windowHeight * 0.75;
            const endThreshold = windowHeight * 0.25;
            const totalActiveDistance = startThreshold - (endThreshold - rect.height);
            const currentDistance = startThreshold - rect.top;
            let progress = currentDistance / totalActiveDistance;
            progress = Math.max(0, Math.min(1, progress));
            elevator.style.top = `${progress * 100}%`;
        };
        handleScroll();

        window.addEventListener('scroll', () => {
            window.requestAnimationFrame(handleScroll);
        }, { passive: true });
    });
});